var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-alert kt-alert--outline alert alert-dismissible",class:'alert-'+_vm.type,attrs:{"role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}}),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }